const ADJECTIVES = [
  'admiring',
  'adoring',
  'affectionate',
  'agitated',
  'amazing',
  'angry',
  'awesome',
  'beautiful',
  'blissful',
  'bold',
  'boring',
  'brave',
  'busy',
  'charming',
  'clever',
  'cool',
  'compassionate',
  'competent',
  'condescending',
  'confident',
  'cranky',
  'crazy',
  'dazzling',
  'determined',
  'distracted',
  'dreamy',
  'eager',
  'ecstatic',
  'elastic',
  'elated',
  'elegant',
  'eloquent',
  'epic',
  'exciting',
  'fervent',
  'festive',
  'flamboyant',
  'focused',
  'friendly',
  'frosty',
  'funny',
  'gallant',
  'gifted',
  'goofy',
  'gracious',
  'great',
  'happy',
  'hardcore',
  'heuristic',
  'hopeful',
  'hungry',
  'infallible',
  'inspiring',
  'interesting',
  'intelligent',
  'jolly',
  'jovial',
  'keen',
  'kind',
  'laughing',
  'loving',
  'lucid',
  'magical',
  'mystifying',
  'modest',
  'musing',
  'naughty',
  'nervous',
  'nice',
  'nifty',
  'nostalgic',
  'objective',
  'optimistic',
  'peaceful',
  'pedantic',
  'pensive',
  'practical',
  'priceless',
  'quirky',
  'quizzical',
  'recursing',
  'relaxed',
  'reverent',
  'romantic',
  'sad',
  'serene',
  'sharp',
  'silly',
  'sleepy',
  'stoic',
  'strange',
  'stupefied',
  'suspicious',
  'sweet',
  'tender',
  'thirsty',
  'trusting',
  'unruffled',
  'upbeat',
  'vibrant',
  'vigilant',
  'vigorous',
  'wizardly',
  'wonderful',
  'xenodochial',
  'youthful',
  'zealous',
  'zen',
]

const DIRECTOR_FULL_NAMES = [
  'Akira Kurosawa',
  'Alejandro G. Iñárritu',
  'Alfonso Cuarón',
  'Alfred Hitchcock',
  'Andrei Tarkovsky',
  'Andrzej Wajda',
  'Anthony Minghella',
  'Bernardo Bertolucci',
  'Billy Wilder',
  'Blake Edwards',
  'Brian De Palma',
  'Buster Keaton',
  'Carl Theodor Dreyer',
  'Charles Chaplin',
  'Christopher Nolan',
  'Clint Eastwood',
  'Costa-Gavras',
  'D.W. Griffith',
  'David Cronenberg',
  'David Fincher',
  'David Lean',
  'David Lynch',
  'Elia Kazan',
  'Emir Kusturica',
  'F.W. Murnau',
  'Federico Fellini',
  'Francis Ford Coppola',
  'Frank Capra',
  'Frank Darabont',
  'François Truffaut',
  'Fred Zinnemann',
  'Fritz Lang',
  'Giuseppe Tornatore',
  'Gus Van Sant',
  'Hayao Miyazaki',
  'Howard Hawks',
  'Ingmar Bergman',
  'Jafar Panahi',
  'James Cameron',
  'Jean Renoir',
  'Jean-Luc Godard',
  'Jean-Pierre Dardenne',
  'Jean-Pierre Jeunet',
  'Jean-Pierre Melville',
  'Jim Jarmusch',
  'Jim Sheridan',
  'Joel Coen',
  'John Ford',
  'John Huston',
  'Kaige Chen',
  'Kar-Wai Wong',
  'King Vidor',
  'Krzysztof Kieslowski',
  'Lars von Trier',
  'Luis Buñuel',
  'Martin Scorsese',
  'Mel Brooks',
  'Mel Gibson',
  'Michael Curtiz',
  'Michael Haneke',
  'Michael Mann',
  'Michelangelo Antonioni',
  'Mike Nichols',
  'Milos Forman',
  'Oliver Stone',
  'Orson Welles',
  'Paul Thomas Anderson',
  'Pedro Almodóvar',
  'Peter Jackson',
  'Preston Sturges',
  'Quentin Tarantino',
  'Rainer Werner Fassbinder',
  'Richard Brooks',
  'Ridley Scott',
  'Robert Altman',
  'Robert Bresson',
  'Robert Rodriguez',
  'Robert Rossen',
  'Roman Polanski',
  'Ron Howard',
  'Sam Mendes',
  'Sam Peckinpah',
  'Sergio Leone',
  'Sidney Lumet',
  'Spike Jonze',
  'Stanley Kubrick',
  'Steven Soderbergh',
  'Steven Spielberg',
  'Sydney Pollack',
  'Takeshi Kitano',
  'Terry Gilliam',
  'Theodoros Angelopoulos',
  'Tim Burton',
  'Tom Tykwer',
  'Vittorio De Sica',
  'Werner Herzog',
  'Wes Anderson',
  'William Wyler',
  'Woody Allen',
  'Yimou Zhang',
]

const ANIMALS = [
  'earthworm',
  'leech',
  'worm',
  'scorpion',
  'spider',
  'tarantula',
  'barnacle',
  'crab',
  'crayfish',
  'lobster',
  'pillbug',
  'prawn',
  'shrimp',
  'ant',
  'bee',
  'beetle',
  'bug',
  'bumblebee',
  'butterfly',
  'caterpillar',
  'cicada',
  'cricket',
  'dragonfly',
  'earwig',
  'firefly',
  'grasshopper',
  'honeybee',
  'hornet',
  'inchworm',
  'ladybug',
  'locust',
  'mantis',
  'mayfly',
  'mosquito',
  'moth',
  'sawfly',
  'silkworm',
  'termite',
  'wasp',
  'woodlouse',
  'centipede',
  'millipede',
  'pronghorn',
  'antelope',
  'bison',
  'buffalo',
  'bull',
  'chamois',
  'cow',
  'gazelle',
  'gaur',
  'goat',
  'ibex',
  'impala',
  'kudu',
  'markhor',
  'mouflon',
  'muskox',
  'nyala',
  'sheep',
  'wildebeest',
  'yak',
  'zebu',
  'alpaca',
  'camel',
  'llama',
  'vicugna',
  'caribou',
  'chital',
  'deer',
  'elk',
  'moose',
  'pudu',
  'reindeer',
  'sambar',
  'wapiti',
  'beluga',
  'dolphin',
  'narwhal',
  'orca',
  'porpoise',
  'whale',
  'donkey',
  'horse',
  'stallion',
  'zebra',
  'giraffe',
  'okapi',
  'hippo',
  'rhino',
  'boar',
  'hog',
  'pig',
  'swine',
  'warthog',
  'peccary',
  'buzzard',
  'eagle',
  'goshawk',
  'harrier',
  'hawk',
  'vulture',
  'duck',
  'goose',
  'swan',
  'teal',
  'bird',
  'hummingbird',
  'swift',
  'kiwi',
  'potoo',
  'seriema',
  'cassowary',
  'emu',
  'condor',
  'auk',
  'avocet',
  'guillemot',
  'kittiwake',
  'puffin',
  'seagull',
  'skua',
  'stork',
  'dodo',
  'dove',
  'pigeon',
  'kingfisher',
  'tody',
  'bustard',
  'coua',
  'coucal',
  'cuckoo',
  'koel',
  'malkoha',
  'roadrunner',
  'kagu',
  'caracara',
  'falcon',
  'kestrel',
  'chachalaca',
  'chicken',
  'curassow',
  'grouse',
  'guan',
  'junglefowl',
  'partridge',
  'peacock',
  'pheasant',
  'quail',
  'rooster',
  'turkey',
  'loon',
  'coot',
  'crane',
  'turaco',
  'hoatzin',
  'bullfinch',
  'crow',
  'jackdaw',
  'jaybird',
  'finch',
  'lyrebird',
  'magpie',
  'myna',
  'nightingale',
  'nuthatch',
  'oriole',
  'oxpecker',
  'raven',
  'robin',
  'rook',
  'skylark',
  'sparrow',
  'starling',
  'swallow',
  'waxbill',
  'wren',
  'heron',
  'ibis',
  'jacamar',
  'piculet',
  'toucan',
  'toucanet',
  'woodpecker',
  'flamingo',
  'grebe',
  'albatross',
  'fulmar',
  'petrel',
  'spoonbill',
  'ara',
  'cockatoo',
  'kakapo',
  'lorikeet',
  'macaw',
  'parakeet',
  'parrot',
  'penguin',
  'ostrich',
  'boobook',
  'owl',
  'booby',
  'cormorant',
  'frigatebird',
  'pelican',
  'quetzal',
  'trogon',
  'axolotl',
  'bullfrog',
  'frog',
  'newt',
  'salamander',
  'toad',
  'angelfish',
  'barracuda',
  'carp',
  'catfish',
  'dogfish',
  'goldfish',
  'guppy',
  'eel',
  'flounder',
  'herring',
  'lionfish',
  'mackerel',
  'oarfish',
  'perch',
  'salmon',
  'seahorse',
  'sturgeon',
  'sunfish',
  'tench',
  'trout',
  'tuna',
  'wrasse',
  'sawfish',
  'shark',
  'stingray',
  'jellyfish',
  'alligator',
  'caiman',
  'crocodile',
  'gharial',
  'starfish',
  'urchin',
  'hedgehog',
  'coyote',
  'dingo',
  'dog',
  'fennec',
  'fox',
  'hound',
  'jackal',
  'tanuki',
  'wolf',
  'bobcat',
  'caracal',
  'cat',
  'cougar',
  'jaguar',
  'jaguarundi',
  'leopard',
  'lion',
  'lynx',
  'manul',
  'ocelot',
  'panther',
  'puma',
  'serval',
  'smilodon',
  'tiger',
  'wildcat',
  'aardwolf',
  'binturong',
  'cheetah',
  'civet',
  'fossa',
  'hyena',
  'meerkat',
  'mongoose',
  'badger',
  'coati',
  'ermine',
  'ferret',
  'marten',
  'mink',
  'otter',
  'polecat',
  'skunk',
  'stoat',
  'weasel',
  'wolverine',
  'seal',
  'walrus',
  'raccoon',
  'ringtail',
  'bear',
  'panda',
  'bat',
  'armadillo',
  'elephant',
  'mammoth',
  'mastodon',
  'mole',
  'hyrax',
  'bandicoot',
  'bettong',
  'cuscus',
  'kangaroo',
  'koala',
  'numbat',
  'quokka',
  'quoll',
  'wallaby',
  'wombat',
  'echidna',
  'platypus',
  'tapir',
  'anteater',
  'sloth',
  'agouti',
  'beaver',
  'capybara',
  'chinchilla',
  'chipmunk',
  'degu',
  'dormouse',
  'gerbil',
  'gopher',
  'groundhog',
  'jackrabbit',
  'jerboa',
  'hamster',
  'hare',
  'lemming',
  'marmot',
  'mouse',
  'muskrat',
  'porcupine',
  'rabbit',
  'rat',
  'squirrel',
  'vole',
  'ape',
  'baboon',
  'bonobo',
  'capuchin',
  'chimpanzee',
  'galago',
  'gibbon',
  'gorilla',
  'lemur',
  'lori',
  'macaque',
  'mandrill',
  'marmoset',
  'monkey',
  'orangutan',
  'tamarin',
  'tarsier',
  'uakari',
  'dugong',
  'manatee',
  'shrew',
  'aardwark',
  'clam',
  'cockle',
  'mussel',
  'oyster',
  'scallop',
  'shellfish',
  'ammonite',
  'cuttlefish',
  'nautilus',
  'octopus',
  'squid',
  'limpet',
  'slug',
  'snail',
  'sponge',
  'tuatara',
  'agama',
  'chameleon',
  'dragon',
  'gecko',
  'iguana',
  'lizard',
  'pogona',
  'skink',
  'adder',
  'anaconda',
  'asp',
  'boa',
  'cobra',
  'copperhead',
  'mamba',
  'python',
  'rattlesnake',
  'sidewinder',
  'snake',
  'taipan',
  'viper',
  'tortoise',
  'turtle',
  'dinosaur',
  'raptor',
  'mushroom',
]

const randomElement = <T>(array: Array<T>): T => array[Math.floor(Math.random() * array.length)]

const getLastName = (name: string): string => {
  const sp = name.split(' ')
  return sp[sp.length - 1]
}

const capitalize = (s: string): string => {
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export const generateWorkstationName = (): string => {
  const adj = capitalize(randomElement(ADJECTIVES))
  const surname = getLastName(randomElement(DIRECTOR_FULL_NAMES))
  return `${adj} ${surname}`
}

export const generateDriveName = (): string => {
  const adj = capitalize(randomElement(ADJECTIVES))
  const animal = capitalize(randomElement(ANIMALS))
  return `${adj} ${animal}`
}
